/** Seconds without a heartbeat before a connected user is shown as "away" (admin + client). */
export const PRESENCE_STALE_SECONDS = 10;

/** Seconds a registered bidder may stay "away" before the auction is paused (server-side). */
export const PRESENCE_AWAY_PAUSE_SECONDS = 15;

/** Seconds since last heartbeat before the chip turns amber (admin catalogue users). */
export const PRESENCE_WARNING_SECONDS = 5;
